module.exports = __webpack_public_path__ + "img/btn-windows.53a13e65.png";